import React from 'react';
import Brick from './BrickCore';
import { Field } from 'redux-form';
import { Col, FormGroup, Label } from 'reactstrap';
import {
    getWorkflowContextPathOptionGroups,
    pathSetFromContextPathGroups,
} from '../../containers/Workflows/workflowContextPathOptions';
import ContextPathSelect from '../../components/ContextPathSelect/ContextPathSelect';

/**
 * Loop head over a context array (graph workflows). Outgoing XOR: iterate vs default exit.
 * [server_side]
 */
class ForeachBrick extends Brick {
    /**
     * @returns {string|null}
     */
    getNodeDetails() {
        const itemsPath = this.getOption('items_path');
        if (itemsPath == null)
            return null;

        return this.truncateNodeDetail(itemsPath, 48);
    }

    render_items_path_field = ({ input, context_path_groups, known_context_paths }) => {
        return (
            <ContextPathSelect
                groups={context_path_groups}
                value={input.value}
                onChange={input.onChange}
                knownPaths={known_context_paths}
                customPlaceholder="rows"
            />
        );
    };

    getOptionsForm(props) {
        const { t, workflow, forms } = props;
        const pos = this.position;
        const forms_by_id = (forms || []).reduce((acc, f) => {
            if (f?.id != null) {
                acc[f.id] = f;
            }
            return acc;
        }, {});
        const context_path_groups = getWorkflowContextPathOptionGroups(workflow?.bricks || [], forms_by_id, {}, t);
        const known_context_paths = pathSetFromContextPathGroups(context_path_groups);

        return (
            <>
                <FormGroup row>
                    <Label sm={12}>{t('workflows.bricks.foreach.options.items_path')}</Label>
                    <Col sm={12}>
                        <Field
                            name={`bricks[${pos}].options.items_path`}
                            component={this.render_items_path_field}
                            context_path_groups={context_path_groups}
                            known_context_paths={known_context_paths}
                        />
                    </Col>
                </FormGroup>
                <FormGroup row>
                    <Label sm={12}>{t('workflows.bricks.foreach.options.item_key')}</Label>
                    <Col sm={12}>
                        <Field
                            component="input"
                            type="text"
                            name={`bricks[${pos}].options.item_key`}
                            className="form-control"
                        />
                        <small className="form-text text-muted">
                            {t('workflows.bricks.foreach.options.item_key_help')}
                        </small>
                    </Col>
                </FormGroup>
                <FormGroup row>
                    <Label sm={12}>{t('workflows.bricks.foreach.options.index_key')}</Label>
                    <Col sm={12}>
                        <Field
                            component="input"
                            type="text"
                            name={`bricks[${pos}].options.index_key`}
                            className="form-control"
                        />
                        <small className="form-text text-muted">
                            {t('workflows.bricks.foreach.options.index_key_help')}
                        </small>
                    </Col>
                </FormGroup>
                <FormGroup row>
                    <Label sm={12}>{t('workflows.bricks.foreach.options.max_iterations')}</Label>
                    <Col sm={12}>
                        <Field
                            component="input"
                            type="number"
                            name={`bricks[${pos}].options.max_iterations`}
                            className="form-control"
                        />
                    </Col>
                </FormGroup>
            </>
        );
    }
}

export default ForeachBrick;
